var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5.25H19.5V3.75C19.5 3.55109 19.421 3.36032 19.2803 3.21967C19.1397 3.07902 18.9489 3 18.75 3H15.75C15.5511 3 15.3603 3.07902 15.2197 3.21967C15.079 3.36032 15 3.55109 15 3.75V5.25H9V3.75C9 3.55109 8.92098 3.36032 8.78033 3.21967C8.63968 3.07902 8.44891 3 8.25 3H5.25C5.05109 3 4.86032 3.07902 4.71967 3.21967C4.57902 3.36032 4.5 3.55109 4.5 3.75V5.25H3.75C3.15326 5.25 2.58097 5.48705 2.15901 5.90901C1.73705 6.33097 1.5 6.90326 1.5 7.5V18.75C1.5 19.3467 1.73705 19.919 2.15901 20.341C2.58097 20.7629 3.15326 21 3.75 21H20.25C20.8467 21 21.419 20.7629 21.841 20.341C22.2629 19.919 22.5 19.3467 22.5 18.75V7.5C22.5 6.90326 22.2629 6.33097 21.841 5.90901C21.419 5.48705 20.8467 5.25 20.25 5.25ZM16.5 4.5H18V5.25H16.5V4.5ZM6 4.5H7.5V5.25H6V4.5ZM3.75 6.75H20.25C20.4489 6.75 20.6397 6.82902 20.7803 6.96967C20.921 7.11032 21 7.30109 21 7.5V9H3V7.5C3 7.30109 3.07902 7.11032 3.21967 6.96967C3.36032 6.82902 3.55109 6.75 3.75 6.75ZM20.25 19.5H3.75C3.55109 19.5 3.36032 19.421 3.21967 19.2803C3.07902 19.1397 3 18.9489 3 18.75V10.5H21V18.75C21 18.9489 20.921 19.1397 20.7803 19.2803C20.6397 19.421 20.4489 19.5 20.25 19.5Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.75 15.75H6C5.58579 15.75 5.25 16.0858 5.25 16.5V17.25C5.25 17.6642 5.58579 18 6 18H6.75C7.16421 18 7.5 17.6642 7.5 17.25V16.5C7.5 16.0858 7.16421 15.75 6.75 15.75Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5 12H9.75C9.33579 12 9 12.3358 9 12.75V13.5C9 13.9142 9.33579 14.25 9.75 14.25H10.5C10.9142 14.25 11.25 13.9142 11.25 13.5V12.75C11.25 12.3358 10.9142 12 10.5 12Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5 15.75H9.75C9.33579 15.75 9 16.0858 9 16.5V17.25C9 17.6642 9.33579 18 9.75 18H10.5C10.9142 18 11.25 17.6642 11.25 17.25V16.5C11.25 16.0858 10.9142 15.75 10.5 15.75Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.25 12H13.5C13.0858 12 12.75 12.3358 12.75 12.75V13.5C12.75 13.9142 13.0858 14.25 13.5 14.25H14.25C14.6642 14.25 15 13.9142 15 13.5V12.75C15 12.3358 14.6642 12 14.25 12Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.25 15.75H13.5C13.0858 15.75 12.75 16.0858 12.75 16.5V17.25C12.75 17.6642 13.0858 18 13.5 18H14.25C14.6642 18 15 17.6642 15 17.25V16.5C15 16.0858 14.6642 15.75 14.25 15.75Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18 12H17.25C16.8358 12 16.5 12.3358 16.5 12.75V13.5C16.5 13.9142 16.8358 14.25 17.25 14.25H18C18.4142 14.25 18.75 13.9142 18.75 13.5V12.75C18.75 12.3358 18.4142 12 18 12Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18 15.75H17.25C16.8358 15.75 16.5 16.0858 16.5 16.5V17.25C16.5 17.6642 16.8358 18 17.25 18H18C18.4142 18 18.75 17.6642 18.75 17.25V16.5C18.75 16.0858 18.4142 15.75 18 15.75Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSchedule);
export default __webpack_public_path__ + "static/media/WhiteSchedule.c93e2f108b6742c5d4ebb6471ff13d1c.svg";
export { ForwardRef as ReactComponent };